import classNames from 'classnames'

import { HTML_LINK_TARGET } from '../../../constants/html'
import { useLinkLikeClick } from '../../../hooks'
import { Avatar, AVATAR_HEIGHT_32 } from '../../Avatar'
import Text from '../../Text'
import { QA_NAME_CHATROOM_MESSAGE_AUTHOR } from '../Chatroom.constants'

import * as styles from './ChatroomMessageHeader.module.css'

function ChatroomMessageHeader({
  avatar,
  color,
  fullName,
  headerText,
  profileToLink,
}) {
  const { handleClick } = useLinkLikeClick()

  function handleClickAuthor(event) {
    handleClick({ event, link: profileToLink, target: HTML_LINK_TARGET.blank })
  }

  return (
    <div className={styles.chatroomMessageHeader}>
      <Avatar
        color={color}
        size={AVATAR_HEIGHT_32}
        src={avatar}
        text={fullName}
      />
      <Text
        className={classNames(styles.headerInfo, {
          [styles.blocked]: !profileToLink,
        })}
        qaName={QA_NAME_CHATROOM_MESSAGE_AUTHOR}
        onClick={profileToLink ? handleClickAuthor : undefined}
      >
        {headerText}
      </Text>
    </div>
  )
}

export default ChatroomMessageHeader
